// extracted by mini-css-extract-plugin
export default {"Box":"label-module__Box--XVnPu","StateLabel":"label-module__StateLabel--KyYgp","Text":"label-module__Text--Y3NL6"};